export const environment = {
  name: 'test',
  production: false,
  authUrl: 'https://shared-authentication-service.test.travelhq.com/',
  programkey: '1F7B6CA2-0C15-44EF-8145-B3DB8D0B23D9'
} as const;
